export const PRICING_TIERS = [
  {
    id: "1_item",
    name: "Single",
    price: 59,
    itemCount: 1,
    tagline: "One thing to toss",
    examples: [
      { label: "Couch", img: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=480&q=70" },
      { label: "Mattress", img: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=480&q=70" },
      { label: "Recliner", img: "https://images.unsplash.com/photo-1519947486511-46149fa0a254?auto=format&fit=crop&w=480&q=70" },
      { label: "TV", img: "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=480&q=70" },
    ],
  },
  {
    id: "2_items",
    name: "Duo",
    price: 99,
    itemCount: 2,
    tagline: "Two items, one trip",
    examples: [
      { label: "Sofa + Loveseat", img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=480&q=70" },
      { label: "Fridge + Stove", img: "https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=480&q=70" },
      { label: "Dresser + Bed frame", img: "https://images.unsplash.com/photo-1505693314120-0d443867891c?auto=format&fit=crop&w=480&q=70" },
      { label: "Washer + Dryer", img: "https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?auto=format&fit=crop&w=480&q=70" },
    ],
  },
  {
    id: "3_items",
    name: "Trio",
    price: 149,
    itemCount: 3,
    tagline: "Three items, one trip",
    examples: [
      { label: "3-piece sectional", img: "https://images.unsplash.com/photo-1550226891-ef816aed4a98?auto=format&fit=crop&w=480&q=70" },
      { label: "Washer + Dryer + Refrigerator", img: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=480&q=70" },
      { label: "2 dressers + bed frame", img: "https://images.unsplash.com/photo-1595428774223-ef52624120d2?auto=format&fit=crop&w=480&q=70" },
    ],
  },
  {
    id: "4_plus",
    name: "Haul",
    price: 199,
    itemCount: 4,
    tagline: "4 items — add up to 4 more",
    pricingNote: "+$49 per additional item (up to 8 total)",
    fullServiceNote: "Full clean-outs? Call us for pricing.",
    examples: [
      { label: "4 items (base $199)", img: "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?auto=format&fit=crop&w=480&q=70" },
      { label: "+$49 per extra item", img: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?auto=format&fit=crop&w=480&q=70" },
      { label: "Up to 8 items max", img: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=480&q=70" },
    ],
    plus: true,
  },
];

// Gallery of furniture staged at curb/driveway — shows customers how to prep
export const STAGING_GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_trash-removal-cle/artifacts/ac6m1px9_comegetmytrashcouch.png",
    caption: "Couch in driveway — just leave it, we'll grab it",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_trash-removal-cle/artifacts/q5pg5acj_haulcomegetmytrash.png",
    caption: "Driveway pile — no need to be home",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_trash-removal-cle/artifacts/a527gip2_workercomegetmytrash.png",
    caption: "Stage, leave, we handle the rest",
  },
];

export const SERVICE_AREAS = [
  "Cleveland",
  "East Cleveland",
  "Shaker Heights",
  "Beachwood",
  "Cleveland Heights",
  "South Euclid",
  "Lakewood",
  "Parma",
  "Brecksville",
  "Rocky River",
  "Westlake",
  "Strongsville",
  "Solon",
  "Mayfield Heights",
  "Independence",
];

export const WE_REMOVE = [
  "Furniture (couches, chairs, tables, beds)",
  "Mattresses & box springs",
  "Appliances (fridges, stoves, washers)",
  "Electronics & TVs",
  "Yard waste & old fencing",
  "Construction debris (small loads)",
  "Hot tubs & play sets (disassembled)",
  "General household junk",
];

export const WE_DONT_REMOVE = [
  "Hazardous waste (paint, chemicals, oil)",
  "Asbestos or mold-contaminated items",
  "Medical waste",
  "Fuel, propane tanks",
  "Ammunition or explosives",
  "Anything radioactive",
];

export const FAQ_ITEMS = [
  {
    q: "How fast can you come out?",
    a: "Most jobs in Cuyahoga County get same-day or next-day pickup. Book by 10 AM for same-day availability (subject to capacity).",
  },
  {
    q: "Where should I stage my items?",
    a: "Curbside is preferred. Driveway works too. If you need us to come back for something in a garage or basement, pick it in the booking form and we'll sort it on arrival.",
  },
  {
    q: "Do you accept credit cards?",
    a: "Yes — we accept all major credit cards via Stripe Checkout. Payment is collected at booking, so you're locked in before we roll out. Your receipt is emailed automatically.",
  },
  {
    q: "What happens to items after removal?",
    a: "We recycle or donate whenever possible. Working appliances and furniture go to local charities. What's left goes to licensed transfer stations.",
  },
  {
    q: "What if something gets damaged?",
    a: "We're fully insured. In the rare event we damage property, just let us know and we'll make it right.",
  },
  {
    q: "Can you remove a specific item I'm not sure about?",
    a: "Text us a photo before booking. We'll confirm pricing and whether we can haul it.",
  },
  {
    q: "Do you serve outside Cuyahoga County?",
    a: "We currently focus on Cuyahoga County. Reach out — we may still be able to help depending on the job.",
  },
];

export const BENEFITS = [
  { title: "Transparent Pricing", desc: "Flat-rate tiers. The price we quote is the price you pay. Always." },
  { title: "Reliable Service", desc: "We show up in the scheduled window. If we can't, we call. Simple as that." },
  { title: "Local & Trustworthy", desc: "Cleveland-born. Fully insured, licensed, and background-checked crew." },
  { title: "Eco-Friendly", desc: "We recycle and donate whenever possible to keep junk out of the landfill." },
  { title: "Easy Booking", desc: "Book online in under 2 minutes. No quotes, no phone tag, no surprises." },
  { title: "Professional Crew", desc: "Trained, respectful, uniformed team that treats your property like their own." },
];

export const STAGING_LOCATIONS = [
  { id: "curb", label: "Curbside" },
  { id: "driveway", label: "Driveway" },
];
